export default __webpack_public_path__ + "static/media/ds.2fb674cd.jpg";